import { sortBy } from 'lodash';
import * as jsts from 'jsts';

import { doubleToString } from '../../utilities';
import { CONTENT_TYPE_ID } from '../../../constants';

import LinearRing from 'ol/geom/LinearRing';
import {
    LineString,
    MultiLineString,
    MultiPoint,
    MultiPolygon,
    Point,
    Polygon,
} from 'ol/geom';
import Feature from 'ol/Feature';

export function extendFeature(feature, layerData, layerSource) {
    // TODO can this be removed
    const id = feature.getId();
    const extendedFeature = feature;

    extendedFeature.id = id;
    extendedFeature.themelayer = layerData;
    extendedFeature.title = layerData.title;

    if (layerData.feedback && layerData.feedback.contentTypeId === CONTENT_TYPE_ID.MEASUREMENT) {
        extendedFeature.feedbackMeasureGeometry = feature.getProperties()['geometry'];
    }

    extendedFeature.columns = sortBy(layerData.informationAttributes, 'order');
    extendedFeature.properties = extendedFeature.columns.map(column => {
        return {
            value: feature.getProperties()[column.attribute],
            attribute: column.attribute,
            displayInTable: column.displayInTable,
            displayInPopup: column.displayInPopup,
            displayInDetail: column.displayInDetail,
            hyperlink: column.hyperlink,
            hyperlinkText: column.hyperlinkText,
            hyperlinkExpression: column.hyperlinkExpression,
            hyperlinkImage: column.hyperlinkImage,
            openExtern: column.openExtern
        };
    });

    extendedFeature.value = (columnName) => {
        if (['length', 'area', 'coord_x', 'coord_y'].includes(columnName)) {
            return doubleToString(feature.getProperties()[columnName]);
        }
        return feature.getProperties()[columnName];
    };
    return extendedFeature;
}

// uses jsts:
// http://bjornharrtell.github.io/jsts/
// https://openlayers.org/en/latest/examples/jsts.html?q=jsts

export function joinFeatures(features, buffer) {
    var parser = new jsts.io.OL3Parser();
    parser.inject(
        Point,
        LineString,
        LinearRing,
        Polygon,
        MultiPoint,
        MultiLineString,
        MultiPolygon
    );

    // read geometry
    const parsed = features.map(feature =>  parser.read( feature.getGeometry()));

    // apply buffer if needed
    const buffered = buffer > 0 ? parsed.map(jstsFeature => jstsFeature.buffer(buffer)) : parsed;

    const joined = features.length === 1 ? buffered[0] : buffered.reduce(
        // combine the features
        (agg, jstsFeature) => {
            if (agg) {
                // if fails, skip
                try {
                    // uses union function from jsts:
                    return agg.union(jstsFeature);
                } catch {
                    return agg;
                }
            }
            return jstsFeature;
        },
        // start with null
        null
    );

    const joinedFeature =  new Feature();
    joinedFeature.setGeometry(parser.write(joined));
    return joinedFeature;

}

